import 'plugins';

import React from 'react';
import Router from './Router';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import store from 'core/store';
import { antdTheme } from 'styles/antdTheme';
import 'styles/App.sass';

// Mask blur was antd's default in 6.0-6.2 and opt-in since 6.3; restore it
// for modals and drawers. Explicit maskClosable props on modals still apply
// (the context config only supplies what the prop leaves unset).
const maskBlur = { mask: { blur: true } };

// Statics (message.*, notification.*, Modal.confirm) render outside the React
// tree, so they cannot see the ConfigProvider below; holderRender wraps their
// holders with the same theme. Covers the notification calls in redux files too.
ConfigProvider.config({
	holderRender: (children) => (
		<ConfigProvider theme={antdTheme} modal={maskBlur} drawer={maskBlur} popupMatchSelectWidth={false}>
			{children}
		</ConfigProvider>
	),
});

// popupMatchSelectWidth false: open dropdowns size to their options instead
// of pinning to the control, so options stay fully readable wherever a
// select flexes narrow (filter rows, header grids, capped modals).
const App = () => (
	<ConfigProvider theme={antdTheme} modal={maskBlur} drawer={maskBlur} popupMatchSelectWidth={false}>
		<Provider store={store}>

			<Router />

		</Provider>
	</ConfigProvider>
);


export default App;
